import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import equals from 'ramda/src/equals';
import { PropTypes, getContext } from 'proper-types';
import { compose } from 'recompose';
import { Motion as ReactMotion, spring as reactMotionString } from 'react-motion';
export var spring = reactMotionString;

var ReactMotionPrimitives = /*#__PURE__*/function (_Component) {
  _inherits(ReactMotionPrimitives, _Component);

  var _super = _createSuper(ReactMotionPrimitives);

  function ReactMotionPrimitives() {
    var _this;

    _classCallCheck(this, ReactMotionPrimitives);

    _this = _super.call(this);
    _this.state = {
      inMotion: false,
      isRequestAnimationFrameAvailable: false,
      rafID: false
    };
    _this.handleRest = _this.handleRest.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ReactMotionPrimitives, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // in rare case our component is rendered in hidden iframe the animation breaks,
      // so we need to check for that and skip ReactMotion, then we will still get the
      // transition, but it's going to be immediate and without animation
      if (typeof window !== 'undefined' && window.requestAnimationFrame && typeof window.requestAnimationFrame === 'function') {
        this.setState({
          rafID: window.requestAnimationFrame(function () {
            _this2.setState({
              isRequestAnimationFrameAvailable: true
            });
          })
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined' && window.cancelAnimationFrame && typeof window.cancelAnimationFrame === 'function') {
        window.cancelAnimationFrame(this.state.rafID);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!this.props.disableAnimations && !equals(prevProps.style, this.props.style)) {
        this.setState({
          inMotion: true
        });
        this.props.onStartFpsCollection && this.props.onStartFpsCollection();
      }
    }
  }, {
    key: "handleRest",
    value: function handleRest() {
      this.props.onRest && this.props.onRest();

      if (this.state.inMotion) {
        this.setState({
          inMotion: false
        });
        this.props.onEndFpsCollection && this.props.onEndFpsCollection();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          defaultStyle = _this$props.defaultStyle,
          disableAnimations = _this$props.disableAnimations,
          style = _this$props.style;
      var adapted = Object.keys(style).reduce(function (acc, key) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, style[key].val));
      }, {});
      return disableAnimations || !this.state.isRequestAnimationFrameAvailable ? children(adapted) : /*#__PURE__*/React.createElement(ReactMotion, {
        style: style,
        defaultStyle: defaultStyle,
        onRest: this.handleRest
      }, children);
    }
  }]);

  return ReactMotionPrimitives;
}(Component);

export var Motion = compose(getContext({
  disableAnimations: PropTypes.bool,
  onStartFpsCollection: PropTypes.func,
  onEndFpsCollection: PropTypes.func
}))(ReactMotionPrimitives);
//# sourceMappingURL=index.js.map